export const links = [
  {
    id: "about",
    text: "About",
    url: "#about",
  },
  {
    id: "featured",
    text: "Featured",
    url: "#featured",
  },
  {
    id: "roadmap",
    text: "RoadMap",
    url: "#roadmap",
  },
  {
    id: "team",
    text: "Team",
    url: "#team",
  },
]

export const maxMint = 3333

export const loadingSeconds = 3
